import React, { useEffect } from 'react';
import LoadingCircle from '@cpg-its/ads.common.loading-circle';
import { useDispatch, useSelector } from 'react-redux';
import { PageContainer } from '../../../../global/components/layout/page-container';
import { MyCpgMidyearCoverageForm } from './mycpg-coverage-form';
import { setCurrentMyCpgMidYearStep } from './my-cpg-mid-year-slice';
import { BenefitEnrollmentStep } from '../../../arc/features/new-hire-enrollment/models/pension-enrollment-models';
import { useMyCpgMidyearState } from './hooks/useMyCpgMidYearState';
import { gridPageStyles } from '../../../../global/constants/theme/styles/layout/grid-page-layout';
import { TcsmStates } from '../../../../root/tcsm-model';
import { ApiStatuses } from '../../../../global/models/api-model';
import { ApiErrorPage } from '../../../../global/components/api-error-page';
import { NewHireProps } from '../../../arc/models/arc-epi-props';



export function MyCPGMidYearCoverage() {

	const dispatch = useDispatch();
	const loaded = useMyCpgMidyearState();
	const pageClasses = gridPageStyles();
	const error = useSelector<TcsmStates, ApiStatuses>(state => state.newHireEnrollmentState?.apiError);
	const newHireProps = useSelector<TcsmStates, NewHireProps>(state => state.epiProps?.newHireSettingsState?.epiContent);

	useEffect(() => {
		dispatch(setCurrentMyCpgMidYearStep(BenefitEnrollmentStep.COVERAGE));
	}, []);


	if (error === ApiStatuses.Failure) {
		return <ApiErrorPage error={newHireProps?.unExpectedApiErorrMessage} />;
	}

	if (!loaded) {
		return <LoadingCircle />;
	}

	return (
		<PageContainer>
			<div className={pageClasses.gridPageContainer}>
				<MyCpgMidyearCoverageForm />
			</div>
		</PageContainer>
	);
}